<template>
  <div class="box">

    <div class="logo">
      <img src="../../assets/success.png" />
      <p>支付成功</p>
    </div>
    <div class="btn-box">
      <!-- <button type="success" @click="routeGo">查看订单详情</button> -->
      <button
        class="home"
        @click="Home"
      >返回首页</button>
    </div>
    <!-- <van-button type="primary">主要按钮</van-button> -->
  </div>
</template>
<script>
import { Button } from 'vant';

export default {
  components: {
    [Button.name]: Button,
  },
  methods: {
    Home () {
      this.$router.replace({
        path: '/'
      })
    },
    routeGo () {
      this.$router.replace({
        name: 'orderInfo',
        query: {
          odId: this.$route.query.id
        }
      })
    },
    routerBack () {
      this.$router.replace({
        path: '/'
      })
      // if (this.surplus === '积分不足' && getAddressId()) {
      // const payment = paymentHandle.getPayment()
      // if (payment.payType === paymentHandle.type.cart) {
      //   this.$router.replace({
      //     name: 'Car'
      //   })
      // } else {
      //   this.$router.go(-1)
      // }
      // if (payment.payType === paymentHandle.type.buyNow) {
      //   this.$toast({
      //     message: '请选择其它商品',
      //     duration: 2000
      //   })
      //   // setTimeout(() => {
      //   this.$router.replace('/')
      //   // }, 2000);
      //   // }
      // }
    }
  },
  mounted () {
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener('popstate', this.routerBack, false);
    }
  },
  destroyed () {
    window.removeEventListener('popstate', this.routerBack, false);
  },
}
</script>
<style lang="scss" scoped>
.box {
  font-size: 0.12rem;
  text-align: center;
  .logo {
    width: 3rem;
    margin: auto;
    margin-top: 1rem;
    p {
      font-size: 0.5rem;
    }
  }
  .btn-box {
    margin-top: 3rem;
    button {
      width: 6rem;
      border: none;
      padding: 0.2rem;
      background: #ff6161;
      color: white;
      font-size: 0.3rem;
      border-radius: 10px;
      margin-top: 0.2rem;
    }
    .home {
      background: #fff !important;
      color: #ff6161;
      outline: #ff6161;
      border: 1px solid #ff6161;
    }
  }
}
</style>